import { render, staticRenderFns } from "./stereoscopicHistogram2.vue?vue&type=template&id=1bc7a034"
import script from "./stereoscopicHistogram2.vue?vue&type=script&lang=js"
export * from "./stereoscopicHistogram2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports